import "./logo-marquee.css";
import Image from "next/image";
import type { CSSProperties } from "react";
import { cn } from "../../lib/utils";
import type { LogoAsset } from "./types";

type LogoMarqueeProps = {
  logos: LogoAsset[];
  className?: string;
  /** Treatment of each logo, for example `grayscale opacity-70` or `invert`. */
  imageClassName?: string;
  /** Seconds for one full pass. */
  durationSeconds?: number;
};

/**
 * A scrolling row of logos that fades out at both edges. The row is rendered
 * twice so the loop has no seam; the second copy is hidden from screen readers.
 * With reduced motion the row stands still and shows the first logos.
 */
export function LogoMarquee({ logos, className, imageClassName, durationSeconds = 40 }: LogoMarqueeProps) {
  return (
    <div
      className={cn("verbu-logo-marquee flex overflow-hidden", className)}
      style={{ "--verbu-logo-marquee-duration": `${durationSeconds}s` } as CSSProperties}
    >
      {[0, 1].map((copy) => (
        <ul aria-hidden={copy === 1} className="verbu-logo-marquee-track m-0 flex shrink-0 list-none items-center gap-24 p-0 pr-24" key={copy}>
          {logos.map((logo) => (
            <li className="flex shrink-0 items-center" key={logo.name}>
              <Image
                alt={copy === 0 ? logo.name : ""}
                className={cn("w-auto object-contain", imageClassName)}
                src={logo.image}
                style={{ height: logo.height }}
              />
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
}
